module.exports = __webpack_public_path__ + "static/media/amaia-avatar-static.d9024602.svg";